module.exports = __webpack_public_path__ + "static/media/cat01.5bf28cbd.jpg";